export default "__VITE_ASSET__f53a0d0c__"